/**
 * @generated SignedSource<<3562d7e6e047249449fa9f68152e9077>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleExcludeTxnInputObject = {
  perspectiveId?: string | null | undefined;
  ruleId: string;
  txnId: string;
};
export type ruleConflictDialog_ExcludeTxnMutation$variables = {
  input: RuleExcludeTxnInputObject;
};
export type ruleConflictDialog_ExcludeTxnMutation$data = {
  readonly ruleExcludeTxn: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleConflictDialog_ExcludeTxnMutation = {
  response: ruleConflictDialog_ExcludeTxnMutation$data;
  variables: ruleConflictDialog_ExcludeTxnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleConflictDialog_ExcludeTxnMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleExcludeTxnMutationPayload",
        "kind": "LinkedField",
        "name": "ruleExcludeTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleConflictDialog_ExcludeTxnMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleExcludeTxnMutationPayload",
        "kind": "LinkedField",
        "name": "ruleExcludeTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "088ff93bae609ea234b27e559ecfe868",
    "id": null,
    "metadata": {},
    "name": "ruleConflictDialog_ExcludeTxnMutation",
    "operationKind": "mutation",
    "text": "mutation ruleConflictDialog_ExcludeTxnMutation(\n  $input: RuleExcludeTxnInputObject!\n) {\n  ruleExcludeTxn(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02b15ea11368948c7427c3fcfbb76e46";

export default node;
